<template>
    <div>
        <v-card :loading="loading" outlined>
            <v-toolbar dense flat color="blue-grey lighten-5" height="30">
                <v-toolbar-title class="subtitle-1">Compartido con:</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn 
                    v-if="!soloLectura"
                    x-small icon fab 
                    @click="asignarDialog=true">
                    <v-icon>fa-user-plus</v-icon>
                </v-btn>
            </v-toolbar>
            <v-list-item>
                <v-list-item-action>
                    <v-btn icon>
                        <v-icon small color="orange">fa-star</v-icon>
                    </v-btn>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title v-if="tipo == 'entrante'">{{asignacion.titular.usuario.titulo}} {{asignacion.titular.usuario.nombreCompleto}}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-container>
                <v-row no-gutters>
                    <v-col cols="6" v-for="(user,index) in compartido" :key="index" style="padding:4px">
                        <v-list-item>
                            <v-list-item-action>
                                <v-icon small v-if="soloLectura">fa-user</v-icon>
                                <menu-item 
                                    v-else
                                    :items="menuItems(user)"
                                    :id="user.usuario._id"
                                    @menuAction="menuAction"
                                />
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{user.usuario.titulo}} {{user.usuario.nombreCompleto}}</v-list-item-title>
                                <v-list-item-subtitle v-if="user.soloLectura">Sólo lectura</v-list-item-subtitle>
                                <v-list-item-subtitle v-else>Puede modificar</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                </v-row>
            </v-container>

        </v-card>
        <compartir-usuario
        v-if="asignarDialog"
        :mostrar="asignarDialog"
        :oficio="$route.params.id"
        :tipo="tipo"
        @compartidoModificado="compartidoModificado"
        @cancelar="asignarDialog=false"
        />
    </div>
</template>


<script>
import axios from 'axios'
import { mapGetters } from "vuex";
import MenuItem from '../menus/MenuItem'
import CompartirUsuario from './compartirUsuario.vue';

export default {
    props: ['asignacion','compartido','tipo','idOficio','soloLectura'],
    components:{ MenuItem, CompartirUsuario },
    computed:{
        ...mapGetters(["httpURL","sessionToken","userId","role"])
    },
    data: () => ({
        loading: false,
        usuarios: [],
        usuarioSel: null,
        asignarDialog: false,
    }),
    methods:{
        menuItems(user){
            let menu = [];
            if( user.soloLectura ) menu.push({text:'Puede modificar', action: 'changeSoloLectura'});
            else menu.push({text:'Solo lectura', action: 'changeSoloLectura'});
            menu.push({text:'Remover usuario', action: 'removerUsuario'})
            return menu;
        },
        menuAction(action, id){
            switch(action){
                case 'changeSoloLectura':
                    this.changeSoloLectura(id);
                    break;
                case 'removerUsuario':
                    this.removerUsuario(id);
                    break;
            }
            // console.log(action, id);
        },
        compartidoModificado({compartido,log}){
            this.$emit('compartidoModificado',compartido);
            this.$emit('nuevoLog', log)
            this.asignarDialog = false;
                  
        },
        removerUsuario(id){
            // console.log('Remover '+id);
            this.loading = true;
            axios.delete(this.httpURL+'/oficios/'+this.tipo+'/compartido/'+this.idOficio,
                {
                    headers:{token:this.sessionToken},
                    data: {usuario: id}
                })
                .then(res => {
                    // console.log(res.data);
                    if( res.data.ok ){
                        // console.log(res.data);
                        this.$emit('compartidoModificado',res.data.compartido);
                        this.$emit('nuevoLog', res.data.log)
                    }else{
                        this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                    }
                    this.loading = false;
                })
                .catch(error => {
                    // console.log('Error: '+error);
                    this.loading = false;
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                });
        },
        changeSoloLectura(usuario){
            // console.log(usuario,value);
            this.loading = true;
            axios.put(this.httpURL+'/oficios/'+this.tipo+'/compartido/'+this.idOficio+'/soloLectura',
                {usuario},
                {headers:{token:this.sessionToken}})
                .then(res => {
                    // console.log(res.data);
                    if( res.data.ok ){
                        this.$emit('permisoModificado',usuario);
                        this.$emit("nuevoLog", res.data.log)
                    }else{
                        this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                    }
                    this.loading = false;
                })
                .catch(error => {
                    // console.log('Error: '+error);
                    this.loading = false;
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                });
        }
    }
}

</script>